<template>
    <div>
        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
        </div>
        <div class="formulario">
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <h5>Declarações</h5>
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 80%">
                            <label class="label" for="nome">Possui vínculo com alguma Corretora de Valores Mobiliários?
                                (conforme conceito definido na ICVM nº 505/11)**</label>
                            <div class="radio">
                                <input type="radio" id="sim" value="sim" name="VinculoCorretora" class="field__radio"
                                    v-model="localFI.VinculoCorretora" @change="salvarAlteracoesLocalmente" />
                                <label for="simRJI" class="label__radio">
                                    Sim, à {{ nomeEmpresa }}
                                </label>
                                <input type="radio" id="sim-outra" value="sim-outra" name="VinculoCorretora"
                                    class="field__radio" v-model="localFI.VinculoCorretora"
                                    @change="salvarAlteracoesLocalmente" />
                                <label for="simOutra" class="label__radio">
                                    Sim, à outra corretora
                                </label>
                                <input type="radio" id="não" value="não" name="VinculoCorretora" class="field__radio"
                                    v-model="localFI.VinculoCorretora" @change="salvarAlteracoesLocalmente" />
                                <label for="nao" class="label__radio">
                                    Não
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 60%">
                            <label class="label" for="nome">Especificar*</label>
                            <textarea v-model="localFI.FuncaoPublicaRelevanteEspecificacao"
                                @change="salvarAlteracoesLocalmente"
                                style="width: 100%; height: 80px; max-height: 120px;" class="field"></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 70%">
                            <label class="label" for="nome">Possui sócios, administradores, representantes ou
                                relacionamento com pessoas que desempenham ou desempenharam nos últimos 5 anos,no Brasil
                                ou em outros países cargo, emprego ou função pública relevante? *</label>
                            <div class="radio">
                                <input type="radio" id="false" value="false" name="FuncaoPublicaRelevante"
                                    class="field__radio" v-model="localFI.FuncaoPublicaRelevante"
                                    @change="salvarAlteracoesLocalmente" />
                                <label for="simRJI" class="label__radio">
                                    Não
                                </label>
                                <input type="radio" id="true" value="true" name="FuncaoPublicaRelevante"
                                    class="field__radio" v-model="localFI.FuncaoPublicaRelevante"
                                    @change="salvarAlteracoesLocalmente" />
                                <label for="nao" class="label__radio">
                                    Sim
                                </label>
                            </div>
                        </div>
                    </div>
                    <PEP />
                    <DeclaracoesDocumentos />
                </div>
            </div>
        </div>
    </div>
    <ModalInformativoDocumentosDeclaracoes_PJ_Fundos />
    <ModalStatusAssinatura />
</template>

<script>

import { mapGetters } from 'vuex';
import ModalInformativoDocumentosDeclaracoes_PJ_Fundos from '../Documentos/ModalInformativoDocumentosDeclaracoes_PJ_Fundos.vue';
import DeclaracoesDocumentos from './DeclaracoesDocumentos.vue';
import ModalStatusAssinatura from '../Documentos/ModalStatusAssinaturaDeclaracoes_PJ_Fundos.vue';
import PEP from './Pep.vue';

export default {
    name: 'CadastroOutros_OutrasInformacoes',
    props: ['informacoesDeclaracoes', 'Edicao'],
    components: { DeclaracoesDocumentos, ModalInformativoDocumentosDeclaracoes_PJ_Fundos, PEP, ModalStatusAssinatura },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            listaDocumentos: 'GET_LISTA_DOCUMENTOS',
            listaDocumentosCliente: 'GET_LISTA_DOCUMENTOS_CLIENTE'
        }),
    },
    data() {
        return {
            permitirAvancar: false,
            localFI: this.informacoesDeclaracoes,
            nomeEmpresa: ''
        }
    },
    mounted() {
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
    },
    methods: {
        async validarFormulario(submeter) {
            let permitirAvancar = true;
            var nomeDoCampoDocumento = '';

            if (!this.localFI.VinculoCorretora) {
                this.permitirAvancar = false;
                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo Vínculo Corretora é obrigatório e não foi informado, informe para avançar`,
                });
                return;
            }
            if (this.localFI.VinculoCorretora == 'sim-outra' && !this.localFI.FuncaoPublicaRelevanteEspecificacao) {
                permitirAvancar = false;

                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo Vínculo Corretora foi informado como 'sim', é obrigatório especificar este vínculo em 'Especificar*'`,
                });
            }
            if (this.listaDocumentos != null) {
                this.listaDocumentos.forEach(documentoObj => {
                    if (documentoObj.TipoCliente == 'Investidor' && documentoObj.Obrigatoriedade == 'Sim') {
                        if(!this.listaDocumentosCliente){
                            this.permitirAvancar = false;
                            nomeDoCampoDocumento = documentoObj.NomeDocumento;
                        }else if (!this.listaDocumentosCliente.some(p => p != null && documentoObj != null && p.TemplateId === documentoObj.TemplateId) ||
                            this.listaDocumentosCliente.some(p => p != null && documentoObj != null && p.TemplateId === documentoObj.TemplateId && p.StatusAssinatura != 'Assinado')) {
                                this.permitirAvancar = false;
                                nomeDoCampoDocumento = documentoObj.NomeDocumento;
                        }
                    }
                });
            }
            if (submeter && nomeDoCampoDocumento != '') {
                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O documento ` + nomeDoCampoDocumento + ` é obrigatório e não foi assinado, aceito os termos para avançar`,
                });

                permitirAvancar = false;

            }
            this.permitirAvancar = permitirAvancar;
            return permitirAvancar;
        },
        async proximaEtapa() {
            const podeAvancar = await this.validarFormulario(true);

            if (podeAvancar) {
                this.$store.commit('SET_ETAPA_CADASTRO', 7);
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.salvarInformacoes();
            }
        },
        salvarInformacoes() {
            this.$store.commit('SET_FI_SALVAR_INFO', true);
        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_FI_SALVAR_INFO_DECLARACAO', this.localFI);
            //this.validarFormulario();
        },
    }
}

</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.formulario {
    width: 100%;
}

.agrupamentoFormulario {
    width: 100%;
    display: inline-flex;
    margin-top: 10px;
    border-bottom: 1px solid #D0D5DD;
}

.categoriaAgrupamentoFormulario {
    width: 13%;
    margin-right: 15px;
    font-family: 'Inter', sans-serif;

    span {
        font-weight: 400 !important;
        font-size: 13px;
        color: #667085;
    }
}

.label__field {
    padding-right: 30px;
}

.camposAgrupamentoFormulario {
    width: 90%;

    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }

    .accept {
        display: inline-flex;

        &:checked {
            +label {
                &:before {
                    background: white;
                    border: 1px solid black;
                    transition: background 0.3s;
                }
            }

            +label {
                &::after {
                    opacity: 1;
                    transition: all;
                    background: transparent;
                }
            }
        }
    }

    .radio {
        display: flex;
        align-items: center;
        margin-right: 25px;

        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }

        .field__radio {
            width: 20px;
            height: 20px;
        }

        .fieldInRadio {
            border-radius: 8px;
            border: 1px solid #D0D5DD;
            padding: 10px 14px;
            background-color: #F9FAFB;
            width: 55%;
        }

        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
        }
    }

    select {
        width: 105% !important;
    }

    label {
        font-family: 'Inter', sans-serif;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #344054;
        display: block;
        margin-bottom: 8px;
    }
}

.title {

    border-bottom: 1px solid #EAECF0;

    h3 {
        margin-top: 50px;
        color: #101828;
        font-weight: 500;
        font-family: 'Inter', sans-serif;
    }

    h5 {
        margin-top: 5px;
        margin-block-start: 0;
        color: #667085;
        font-weight: 400;
        font-family: 'Inter', sans-serif;
    }
}
</style>